const Roles = {
  EN: [
    { label: "Farmer", id: "Farmer" },
    { label: "Veterinarian", id: "Vet" },
    { label: "Veterinary Drug Shop", id: "Retailer" },
    { label: "Veterinary Pharmacy", id: "Distributor" },
    { label: "Veterinary Para Professional", id: "Paravet" },
    { label: "Government Official", id: "Government" },
  ],
  LU: [
    { label: "Omukazi", id: "Farmer" },
    { label: "Omusawo w'ebyennyanja", id: "Vet" },
    { label: "Sente z'ebyennyanja", id: "Retailer" },
    { label: "Pharmacy y'ebyennyanja", id: "Distributor" },
    { label: "Omukazi w'ebyennyanja", id: "Paravet" },
    { label: "Omukungu", id: "Government" },
  ],
  RY: [
    { label: "Omuhinzi", id: "Farmer" },
    { label: "Omusawo w'ebyennyanja", id: "Vet" },
    { label: "Ekitangazirizo ky'ebyennyanja", id: "Retailer" },
    { label: "Pharmacy y'ebyennyanja", id: "Distributor" },
    { label: "Omunyobwa w'ebyennyanja", id: "Paravet" },
    { label: "Omutungamiri w'egwanga", id: "Government" },
  ],
};

export default Roles;
